import { PermissionT } from "../types";

export const powurAmbassador = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "ambassador");
  return !!p;
};

export default powurAmbassador;
